import React from "react";
import { useSelector } from "react-redux";
import { Contestant, StatsType } from "../../../../types/fixture";
import { Container, Probability } from "./styles";
import { RootState } from "../../../../reducers";

interface Props {
  stats: StatsType[];
  eventContestants: Contestant[];
}

function StatsDisplay({ stats, eventContestants }: Props): JSX.Element {
  const filterStore = useSelector((state: RootState) => state.filter);
  const homeTeam = eventContestants.find(($) => $.position === "home");
  const awayTeam = eventContestants.find(($) => $.position === "away");

  const homeTeamName = homeTeam?.name;
  const awayTeamName = awayTeam?.name;

  const highestStat =
    stats && Math.max(...stats.map((item) => item.probability));

  const renderHighlight = (stat: number) => {
    if (highestStat === 0 && stat === 0) return null;
    if (stat === highestStat) return true;
    return null;
  };

  const renderTeamCode = (item: StatsType) => {
    if (filterStore.market === "TOTAL") {
      if (item.type === "home")
        return item.name || homeTeamName?.substring(0, 3);
      if (item.type === "combined") return "COMBINED";
      if (item.type === "away")
        return item.name || awayTeamName?.substring(0, 3);
      return null;
    } else {
      if (item.type === "home")
        return `${item.name || homeTeamName?.substring(0, 3)}${
          filterStore.market === "SPREAD"
            ? ` ${item.handicap ? item.handicap : ""}`
            : ""
        }`;
      if (item.type === "away")
        return `${item.name || awayTeamName?.substring(0, 3)}${
          filterStore.market === "SPREAD"
            ? ` ${item.handicap ? item.handicap : ""}`
            : ""
        }`;
      return null;
    }
  };

  const renderStats = () => {
    return stats?.map((stat, index) => {
      if (
        filterStore.market === "TOTAL" &&
        filterStore.statsFilter === "h2h" &&
        ((stat.type === "home" && stat.probability > 0) ||
          (stat.type === "away" && stat.probability > 0))
      )
        return null;

      return (
        <div key={stat.name}>
          <Probability highlight={renderHighlight(stat.probability)}>
            {stat.probability ? Math.round(stat.probability * 10) / 10 : 0}%
          </Probability>
          <span>{renderTeamCode(stat)}</span>
        </div>
      );
    });
  };

  return <Container>{renderStats()}</Container>;
}

export default StatsDisplay;
